<template>
  <el-dialog class="convert-key-confirm dialog-base" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }"
    :visible.sync="visible" :title="$t('siteBuild.convert')" width="720px">
    <div class="confirm-content">
      <div class="title flex justify-center w-full">
        <div class="icon-wrap"><i class="el-icon-warning" /></div>
        <span class="info-text">{{ $t('siteBuild.convertTip1') }}</span>
      </div>
      <div class="confirm-content__info mt-8">
        <div class="info-row">
          <span class="label">{{ $t('siteBuild.header.userName') }}:</span>
          <span class="value">{{ userInfo?.name }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t('siteBuild.header.warZone') }}:</span>
          <span class="value">{{ userInfo?.server }}</span>
        </div>
      </div>
      <div class="gift-area">
        <div class="confirm-content__gift w-full flex flex-wrap justify-center my-6 gap-4">
          <div v-for="(item, index) in detail.gift" :key="index" class="item gift-card relative flex items-center flex-col justify-center">
            <img class="card-img object-contain" :src="item.gift_goods_logo" alt="">
            <div class="qty-badge"><i class="el-icon-close"></i><span>{{ item.num }}</span></div>
          </div>
        </div>
      </div>
      <div class="confirm-content__footer text-center mt-8 dialog-actions">
        <button class="dialog-btn cancel" @click="handleCancel">{{ $t('siteBuild.cancel') }}</button>
        <button class="dialog-btn confirm" :disabled="loading" @click="handleSubmit">
          <i v-if="loading" class="el-icon-loading"></i>
          <span>{{ $t('siteBuild.convert') }}</span>
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, Message } from "element-ui"
import { mapState } from "vuex"
import { DeviceEnum } from "~/enums/deviceEnum";

export default {
  name: 'ConvertKeyConfirm',
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    device: {
      type: String,
      default: ''
    },
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false
    }
  },
  computed: {
    DeviceEnum() {
      return DeviceEnum
    },
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo,
      projectId: (state) => state.project.projectId,
    })
  },
  methods: {
    handleCancel() {
      this.visible = false
    },
    init() {
      this.visible = true
    },
    async handleSubmit() {
      const params = {
        project_id: this.projectId,
        redemption_code: this.detail.redemption_code
      }
      this.loading = true
      const [err] = await this.$utils.to(this.$api.convertKey.convert(params))
      this.loading = false
      if (!err) {
        Message.success('Success')
        this.handleCancel()
      } else {
        Message.error(err)
      }
    }
  }
}
</script>

<style lang="less">
@import '../../widgets/common/dialogBase.less';

.convert-key-confirm {
  .info-text {
    word-break: break-word;
    font-size: 16px;
    font-weight: 600;
    color: #111;
  }

  .confirm-content {
    .title {
      gap: 12px;
    }

    .icon-wrap {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: rgba(255, 166, 0, 0.15);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .icon-wrap .el-icon-warning {
      color: @warning-color;
      font-size: 18px;
    }

    &__info {
      width: 80%;
      margin: 0 auto;
      background: #F7F7FA;
      border-radius: 12px;
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .info-row {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      font-size: 16px;
    }

    .label {
      font-weight: 700;
      color: #111;
    }

    .value {
      color: #555;
    }

    &__gift { margin: 20px auto 0 auto; }
    .gift-card {
      width: 70px;
      height: 70px;
      background: linear-gradient(180deg, #F8F8FB 0%, #EFEFF6 100%);
      border: 1px solid rgba(17,17,17,0.12);
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.06);
      overflow: hidden;
      transition: border-color .2s ease, box-shadow .2s ease;
    }
    .gift-card:hover { border-color: rgba(17,17,17,0.18); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
    .gift-card .card-img { max-width: 50px; max-height: 50px; border-radius: 8px; }
    .gift-card .qty-badge { position: absolute; right: 4px; bottom: 4px; display: inline-flex; align-items: center; gap: 4px; padding: 0 6px; line-height: 15px; border-radius: 999px; background: rgba(17,17,17,0.45); color: #fff; font-size: 10px; font-weight: 600; }
    .gift-card .qty-badge .el-icon-close { font-weight: 700; }

    &__footer {}
  }

  .gift-area {
    margin: 0 auto;
    width: 90%;
  }

  &.is-mobile {
    .el-dialog {
      width: 90% !important;
      .confirm-content__gift {
        .gift-card { width: 60px; height: 60px; }
        .gift-card .card-img { max-width: 36px; max-height: 36px; }
        .gift-card .qty-badge { min-height: 14px; line-height: 14px; bottom: 3px; right: 3px; gap: 2px; font-size: 11px; }
      }
    }
  }
}
</style>
